import * as React from 'react';
import { ContractResaleModalViewModel } from '@models/Contract';
import { dateParser } from '@common/dateParser';
import ReactDatePicker from 'react-datepicker';
import { LocalForm, Control, Errors } from 'react-redux-form';
import * as moment from 'moment-timezone';
import { SpinnerPage } from '@common/components/spinner/spinner-page.component';
import { getDefaultErrorMessages } from '@common/validators';
export interface ContractResaleComponentProperties {
  readonly contractResaleModalVM: ContractResaleModalViewModel;
  readonly saveCallback: () => void;
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly isModal: boolean;
  readonly getContractResaleData: (id: number, date: Date) => void;
  readonly isLoadingResale: boolean;
}

export class ContractResaleComponent extends React.Component<ContractResaleComponentProperties> {
  handleSubmit = (formData: { resaleDate: Date }) => {
    this.props.saveCallback();
  };
  handleControlChange = (resaleDate: moment.Moment) => {
    this.props.getContractResaleData(this.props.contractResaleModalVM.contractId, resaleDate.toDate());
  };
  render() {
    if (this.props.isLoadingResale) {
      return <SpinnerPage />;
    }
    if (this.props.contractResaleModalVM) {
      return (
        <LocalForm model="contractResaleForm" hideNativeErrors={true} onSubmit={this.handleSubmit}>
          <div className="row col-md-12">
            Daily Cost of Contract:
            {' $'}
            {this.props.contractResaleModalVM.dailyRate ? this.props.contractResaleModalVM.dailyRate : '--'}
          </div>
          <div className="row col-md-12">
            {' '}
            Premium Subtracted from New Contract:{' '}
            {this.props.contractResaleModalVM.credit ? this.props.contractResaleModalVM.credit : '--'}{' '}
          </div>
          <div className="row col-md-12">
            {' '}
            Amount Paid So Far:{' '}
            {this.props.contractResaleModalVM.amountPaidSoFar
              ? '$' + this.props.contractResaleModalVM.amountPaidSoFar
              : '$0'}{' '}
          </div>
          <div className="row col-md-12">
            {' '}
            Days Remaining on Contract:{' '}
            {this.props.contractResaleModalVM.daysRemaining ? this.props.contractResaleModalVM.daysRemaining : '0'}{' '}
          </div>
          <div className="row col-md-12">
            {' '}
            Contract Start Date:{' '}
            {this.props.contractResaleModalVM.contractStartDate
              ? dateParser
                  .parse(dateParser.toDateString(this.props.contractResaleModalVM.contractStartDate))
                  .format('MM/DD/YYYY')
              : '--'}{' '}
          </div>
          <div className="row col-md-12">
            {' '}
            Contract End Date:{' '}
            {this.props.contractResaleModalVM.contractEndDate
              ? dateParser
                  .parse(dateParser.toDateString(this.props.contractResaleModalVM.contractEndDate))
                  .format('MM/DD/YYYY')
              : '--'}{' '}
          </div>
          <div className="row col-md-12">
            {' '}
            Contract Paid Through Date:{' '}
            {this.props.contractResaleModalVM.paidThrough
              ? dateParser
                  .parse(dateParser.toDateString(this.props.contractResaleModalVM.paidThrough))
                  .format('MM/DD/YYYY')
              : '--'}{' '}
          </div>

          <div className="row col-md-12">
            <div className="form-control col-md-12">
              <label htmlFor="contractResaleForm.resaleDate">Resell Date</label>
              <Control
                model=".resaleDate"
                value={dateParser.toDateString(this.props.contractResaleModalVM.contractResaleDate)}
                component={props => {
                  let val;
                  if (props.value && !moment.isMoment(props.value)) {
                    val = dateParser.parse(props.value);
                  } else {
                    val = props.value;
                  }
                  return (
                    <ReactDatePicker
                      {...props}
                      value={val || moment(dateParser.parse(props.value).format('MM/DD/YYYY'), 'MM/DD/YYYY')}
                      selected={val || moment(dateParser.parse(props.value).format('MM/DD/YYYY'), 'MM/DD/YYYY')}
                      minDate={moment()}
                      onChange={(dateValue: moment.Moment) => {
                        props.onChange(dateValue);
                        this.handleControlChange(dateValue);
                      }}
                    />
                  );
                }}
              />
              <Errors
                className="error"
                model=".resaleDate"
                show={{ touched: true, focus: false }}
                messages={{ ...getDefaultErrorMessages(), validDate: 'Invalid Date' }}
              />
            </div>
            <div className="col-md-12">
              <div className="row end-xs">
                <button
                  className="btn btn-hidden"
                  type="submit"
                  ref={this.props.buttonRef}
                  disabled={this.props.isLoadingResale}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </LocalForm>
      );
    }
    return <h4> This Contract is ineligible for Resale </h4>;
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-resale/contract-resale.component.tsx